import { isValidElement } from 'react'
import clsx from 'clsx'
import { TrendingUp, TrendingDown } from 'lucide-react'
import { Link } from 'react-router-dom'

const colorClasses = {
  primary: { bg: 'bg-primary-50', text: 'text-primary-600', ring: 'ring-primary-100' },
  gold:    { bg: 'bg-gold-50',    text: 'text-gold-600',    ring: 'ring-gold-100'    },
  green:   { bg: 'bg-green-50',   text: 'text-green-600',   ring: 'ring-green-100'   },
  amber:   { bg: 'bg-amber-50',   text: 'text-amber-600',   ring: 'ring-amber-100'   },
  red:     { bg: 'bg-red-50',     text: 'text-red-600',     ring: 'ring-red-100'     },
  blue:    { bg: 'bg-blue-50',    text: 'text-blue-600',    ring: 'ring-blue-100'    },
  purple:  { bg: 'bg-purple-50',  text: 'text-purple-600',  ring: 'ring-purple-100'  },
}

export default function StatCard({
  title, value, subtitle, icon: Icon, trend, color = 'primary',
  link, valueColor
}) {
  const colors = colorClasses[color] || colorClasses.primary

  // Accept BOTH icon styles: icon={Plane} (component type, most callers)
  // and icon={<Plane className="…"/>} (pre-rendered element, the April-era
  // land pages). Rendering an element as a type is React error #130 — it
  // crashed DroneRuns/SoilSamples/VegetationPolygons in prod.
  const iconNode = isValidElement(Icon)
    ? Icon
    : Icon
      ? <Icon className={clsx('h-5 w-5', colors.text)} />
      : null

  const content = (
    <div className={clsx(
      'card p-5 transition-all duration-200',
      link && 'hover:shadow-md hover:border-primary-200 cursor-pointer group'
    )}>
      <div className="flex items-start justify-between mb-3">
        <div className={clsx('p-2.5 rounded-xl ring-1', colors.bg, colors.ring)}>
          {iconNode}
        </div>
        {trend != null && (
          <div className={clsx(
            'flex items-center gap-1 text-xs font-semibold px-2 py-1 rounded-full',
            trend >= 0 ? 'bg-green-50 text-green-700' : 'bg-red-50 text-red-700'
          )}>
            {trend >= 0 ? <TrendingUp className="h-3.5 w-3.5" /> : <TrendingDown className="h-3.5 w-3.5" />}
            {Math.abs(trend)}%
          </div>
        )}
      </div>
      <div className={clsx('text-2xl font-bold tracking-tight leading-none', valueColor || 'text-gray-900')}>
        {value}
      </div>
      <div className="text-sm text-earth-500 mt-1.5 font-medium">{title}</div>
      {subtitle && <div className="text-xs text-earth-400 mt-0.5">{subtitle}</div>}
    </div>
  )

  if (link) return <Link to={link}>{content}</Link>
  return content
}
